import BaseRenameModal from "~/components/Base/RenameModal.vue";

export const useRenameModal = (
  label?: string,
  options?: {
    existingText?: string;
    okButtonLabel?: string;
    cancelButtonLabel?: string;
  }
): Promise<string | undefined> => {
  // Create a promise I can resolve when the userr clsoest he vuefinalmodal

  return new Promise((resolve, reject) => {
    const { open, close } = useDialog({
      component: BaseRenameModal,
      props: {
        label: label ?? "File Name",
        existingText: options?.existingText,
        okButtonLabel: options?.okButtonLabel ?? "Save",
        cancelButtonLabel: options?.cancelButtonLabel ?? "Cancel",
        onConfirm: (fileName: string) => {
          close();
          resolve(fileName);
        },
        onCancel: () => {
          close();
          resolve(undefined);
        },
      },
    });

    open();
  });
};
